<template>
  <transition-group
    :class="['page',
        isLabRootPage ? 'labRootPage':'',
        noPadding ? 'noPadding':'',
        needMenu ? '':'no-menu',
        hasMediaBoxes ? 'has-media' : '',
        !pageReady ? 'still-loading' : '',
        mainFromRoute,
        css
    ]"
    name="page-fade"
    tag="div"
    appear
  >
    <preloader key="preloader" v-if="!pageReady" class="" />
    <div v-else-if="!layout" key="not-found" class="not-found container py-3xl">
      <h1 class="py-2xl" v-text="pageLayoutData"></h1>
      <template v-if="pageLayoutData === 404">
        <h2 class="py-xl">
          Sorry... don't know nothing about this page.
        </h2>
        <h5>Seriously, no clue what your talking about!</h5>
      </template>
      <template v-else>
        <h2 class="py-xl">
        <router-link :to="`/`">Back to homepage</router-link>
        <!--The information just wasn't there :(-->
        </h2>
      </template>
    </div>
    <template v-else>
      <component
        v-for="(comp, index) in layout"
        :key="index"
        :observe-resize="index"
        :size="elementSizes[index]"
        :is="comp.type"
        :resize-trig="resizeTrig"
        :comp-index="index"
        :common-data="commonData"
        v-bind="comp"
        :class="['page-component', `el-size--${elementSizes[index]}`]"
      >
      </component>      
    </template>
  </transition-group>
</template>
<script>
// import resize from "vue-resize-directive";

import { subdomain } from "@/utils";
import { mapState, mapActions } from "vuex";
import LayoutGroup from "@/layout/LayoutGroup.vue";
import LayoutProduct from "@/layout/LayoutProduct.vue";
import Wrapper from "@/layout/Wrapper.vue";
export default {
  props: {
    css: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // pageReady: false,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      observed: null,
      isMatrix: false
    };
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      return {
        inner: this.pageTitle
      };
    },
    meta: function() {
      return [
        { name: "description", content: this.pageDescription, id: "desc" },
        { name: "keywords", content: this.pageKeywords, id: "key" }
      ];
    },
    /*
    //THIS LOGIC REMOVED 
    //NOW THE CANONICAL TAG WILL BE ADDED BY THE SERVER RENDERER TO THE STATIC HTML PAGES
    link: function(){ 
      var _href = "https://www.mis-implants.com"+this.$route.path;
      return [{ rel: 'canonical', href:_href, id: 'canonical' }]
    }*/
  },
  components: {
    LayoutGroup,
    LayoutProduct,
    Wrapper
  },
  watch: {
    pageTitle() {
      this.title = this.pageTitle;
      this.$emit("updateHead");
    },
    $route: async function() {
      this.toggleOverlay(false);
      // this.removeResizeObserver();
      this.setPageReady(false);
      await this.fetchData(this.$route);
      this.setPageReady(true);
      // this.pageReady = true;
      this.privacyPageCookiesAnchor();
    },
    commonData() {
      console.log("common data changed...");
      /*
        TEMPORARY...
        should become generic when another scenario comes along...
      */
      if (this.commonData) {
        let children = this.commonData.children;
        console.log("COUTRY CHILDRAN !>!>", children);
        // storeprop = this.commonData.properties.store;
        this.setCountries(children);
      }
    }
  },
  async created() {
    this.setPageReady(false);
    console.log("page created");
    this.toggleOverlay(false);
    await this.fetchData(this.$route);
    this.setPageReady(true);
  },
  mounted() {
    console.log("page MOUNTED");
    window.addEventListener("resize", this.resizeHandler, false);
    this.privacyPageCookiesAnchor();
  },
  beforeDestroy() {
    console.log("b4destroy");
    this.setPageReady(false);
    this.toggleOverlay(false);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler, false);
  },
  computed: {
    ...mapState(["pageLayoutData", "rawitems", "pageReady"]),
    children() {
      if (!this.pageLayoutData || !this.pageLayoutData.children) return null;
      return this.pageLayoutData.children;
    },
    hasMediaBoxes() 
    {
      let mediaBoxes = _.find(this.children, { type: "media-boxes" });      
      if (mediaBoxes) {return !!mediaBoxes.children.length;}
      return false;
    },
    isLabRootPage()
    {
      var isRootPage = false;
      if(subdomain()=='patient' || subdomain()=='lab'){
          //alert(this.$route.path);
          if(this.$route.path.length<8){
            isRootPage=true;
          }
      }
      return isRootPage;
    },
    needMenu()  
    {
      //var __subdomain = subdomain();
      //alert("__subdomain="+__subdomain);
      if(subdomain()=='patient' || subdomain()=='lab'){
        return false;
      }else{
        return true;
      }
      //return __subdomain == false || __subdomain.length == 0;
    },
    noPadding()
    {
        //Check if we are in a subdomain page and page is not the homepage
        return this.__subdomain!=false && this.$route.path.length>1;
        
        //return true;
    },
    mainFromRoute() {
      let params = this.$route.params;
      if (params && params.main) {
        return _.snakeCase(params.main);
      }
      return "";
    },
    layout() {
      if (!this.children) return null;
      return this.children.filter(item => !this.excludeTypes.test(item.type));
    },
    commonData() {
      if (!this.children || !this.children.length) return null;
      return _.find(this.children, { type: "common-data" });
    },
    excludeTypes() {
      return /(breadcrumbs|media-search-bar|common-data)/;
    },
    pageTitle() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.page_title
        ? this.pageLayoutData.meta.page_title
        : "MIS - Dental Implants Technology";
    },
    pageDescription() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_description
        ? this.pageLayoutData.meta.meta_description
        : "MIS - Dental Implants Technology";
    },
    pageKeywords() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_keywords
        ? this.pageLayoutData.meta.meta_keywords
        : "MIS, dental implants, c1, v3";
    }
  },
  methods: {
    resizeHandler: _.debounce(function() {
      let vm = this;
      if (!this.observed || !this.observed.length) {
        this.observed = document.querySelectorAll("[observe-resize]");
        this.elementSizes.length = this.observed.length;
      }
      // console.log("resize handler", this.observed);
      this.observed.forEach(function(el, index) {
        vm.elementResizeHandler(el, index);
      });
      this.triggerResize();
    }, 300),
    privacyPageCookiesAnchor() {
      let _int;
      console.log("Privacy-Policy route param >> ", this.$route.params);
      if (this.$route.params && this.$route.params.sub === "Privacy-Policy") {
        // In Privacy Policy page.. check if cookies section in query
        if (this.$route.query.hasOwnProperty("cookies")) {
          console.log("scrolll to cookies");
          this.$nextTick(function() {
            _int = setInterval(function() {
              let page = document.querySelector(".page");
              if (page) {
                let h3 = page.querySelectorAll("h3");
                if (h3) {
                  let h3Children = _.toArray(h3);
                  if (h3Children.length) {
                    clearInterval(_int);
                    let _title = h3Children[13];
                    window.scrollTo({
                      top: _title.offsetTop - 30,
                      behavior: "smooth"
                    });
                  }
                }
              }
            }, 1100);
            setTimeout(function() {
              clearInterval(_int);
            }, 5000);
          });
        }
      }
    },
    initResizeElements() {
      this.observed = document.querySelectorAll("[observe-resize]");
      this.elementSizes.length = this.observed.length;
      this.resizeHandler();
    },
    elementResizeHandler(el) {
      if (el) {
        let index = index || el.getAttribute("observe-resize"),
          width = el.offsetWidth;
        if (width > 1200) {
          this.$set(this.elementSizes, index, "large");
        } else if (width > 815) {
          this.$set(this.elementSizes, index, "medium");
        } else {
          this.$set(this.elementSizes, index, "small");
        }
      }
    },
    async fetchData(to) {

      let toFixed =  to.path.replace(/\/+$/, '');//remove trailing slash 

      this.scrollToTop();
      let items = this.rawitems,
        path = toFixed;//to.path;

      // params = to.params;
      if (!items) {
        items = await this.initRawItems();
      }
      console.log("PAGE: fetchData items >> ", items);

      let item = items.find(item => {
        return item.path.toLowerCase().trim() === path.toLowerCase().trim();
      });
      console.log("ITEM >  ", item);
      // console.log("path >  ",path)
      // console.log("params >  ",params)

      //alert(this.$route.path);

      var isRootPage = false;// check if need to load the homepage
      var p = this.$route.path;
      var strDashIndex = p.indexOf("-");
      if(p=="/" || (p.length<8 && strDashIndex==3)){
        isRootPage=true;
      }

      if(subdomain()=='patient' && isRootPage)// && this.$route.path=="/")
      {
          await this.initRouteByPath('patient');//<<This will load the Patient page layout
      }
      else if(subdomain()=='lab' && isRootPage)// && this.$route.path=="/")
      {
          //alert("this.$route.params.locale="+this.$route.params.locale);
          await this.initRouteByPath('lab');
          //await this.initRouteByPath(`/${this.$route.params.locale || "global"}/lab`);//<<This will load the Patient page layout
      }
      else
      {
        if (item && item.cid) {
          this.isMatrix = item.cid === 3418;
          await this.initRouteByCid(item.cid);
        } else {
          //alert(path);

          await this.initRouteByPath(path);
          // console.log("data by path >> ", result);
        }
      }


      this.$nextTick(function() {
        this.initResizeElements();
      });
      return true;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    /*
      Will set off everytime an element has
      resized and will change a random trigger
      that Components can listen to if needed.
    */
    triggerResize() {
      this.resizeTrig = new Date().getTime();
    },
    ...mapActions([
      "setPageReady",
      "initRouteByCid",
      "initRouteByPath",
      // "initMenu",
      "initRawItems",
      "toggleOverlay",
      "setCountries"
    ])
  }
};
</script>
<style lang="stylus" scoped>
.page
  padding-top 30px
  position relative
  min-height 70vh
  background #fff
  z-index 9
  pad('2xl', bottom)
  +below(815px)
    padding-top 30px
  &.labRootPage
    padding-top 30px !important
  &.no-menu
    padding-top 0px
    +below(815px)
      position absolute
      top 0px  
  &.has-media
    +below(815px)
      padding-bottom 380px

  +above(unit($max, 'px'))
    & > *:not(.slider):not(.media-boxes)
      max-width 1720px
      // max-height 700px
      margin-right auto
      margin-left auto
  &.patient-mode
    top -50px
    +below(815px)
      top -20px !important

.not-found
  min-height 80vh

.noPadding
  top 0px !important;

</style>
